import React from "react";
import {
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  useTheme,
} from "@mui/material";
import EGAccordion from "../../../../MainComponents/Accordion/EGAccordion/EGAccordion";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";
import { useTranslation } from "react-i18next";
import { AvatarLetter } from "../../../../MainComponents/Avatar/AvatarLetter";
import Comments from "../../Information/Comments";
import { parseDateToLgComun4 } from "../../../../../helpers/dateTransform";

export const StatusObservations = ({
  reportDetail,
  currentReportStatus,
  mainComment,
  filteredObservations,
  hdlEditCurrentText,
  openModalConfirm,
  hdlDeleteText,
  closeModalConfirm,
}) => {
  const [t] = useTranslation("report");
  const theme = useTheme();

  // Menu options for observations about report status
  const observationsPanel = [
    {
      id: 1,
      title: t("Care.observations"),
      contentBorderColor: theme.palette.blueGray50.main,
      content: (
        <Box
          maxHeight={"37.5vh"}
          sx={{
            overflowY: "auto",
            opacity: mainComment.current === currentReportStatus ? 0.85 : 1,
          }}
          className="rounded"
        >
          {mainComment.current === currentReportStatus &&
            mainComment.comment.trim() !== "" && (
              <Box
                sx={{ py: 1, pl: 2, pr: 0.75 }}
                className={
                  filteredObservations?.length > 0 ? "border-bottom" : ""
                }
              >
                <ListItem
                  sx={{ my: 0, p: 0 }}
                  secondaryAction={
                    <EGIconButton
                      iconName="outline_edit"
                      iconColor="secondary"
                      title={t("Care.edit")}
                      onClick={() =>
                        hdlEditCurrentText(mainComment, "observation")
                      }
                    />
                  }
                >
                  {mainComment.name && (
                    <ListItemAvatar sx={{ scale: 1.4, mr: "-33px" }}>
                      <AvatarLetter contact={mainComment} />
                    </ListItemAvatar>
                  )}
                  <ListItemText
                    primary={mainComment.name || ""}
                    primaryTypographyProps={{ variant: "h6" }}
                    secondary={`${t("Care.updated_on")}: ${parseDateToLgComun4(
                      mainComment.assigned
                    )}`}
                  />
                </ListItem>
                <Comments
                  text={mainComment.comment}
                  maxLength={300}
                  padding={0}
                  sx={{ mx: 0.5 }}
                  variant="body2"
                  color="secondary"
                  fontSize={14}
                />
              </Box>
            )}

          {/* Render the list of filtered observations */}
          {filteredObservations?.length > 0 &&
            filteredObservations.map((observation, i) => (
              <Box
                key={i}
                sx={{ py: 1, pl: 2, pr: 0.75 }}
                className={
                  i < filteredObservations.length - 1 ? "border-bottom" : ""
                }
              >
                <ListItem
                  sx={{ my: 0, p: 0 }}
                  secondaryAction={
                    <EGIconButton
                      iconName="trash_can"
                      iconColor="error"
                      title={t("Care.delete")}
                      placement="top"
                      onClick={() =>
                        openModalConfirm({
                          variant: "error",
                          title: t("Care.warning"),
                          titleColor: theme.palette.pink.main,
                          description1: t(
                            "Care.deleting_this_observation_will_permanently_erase_all_content"
                          ),
                          question: t("Care.do_you_want_continue"),
                          leftButtonText: t("Care.confirm"),
                          leftButtonColor: "error",
                          leftButtonVariant: "outlined",
                          onClickLeft: () => hdlDeleteText(observation),
                          rightButtonText: t("Care.cancel"),
                          rightButtonColor: "secondary",
                          onClickRight: () => closeModalConfirm(),
                          ethiquin: "megaphone",
                        })
                      }
                    />
                  }
                >
                  {observation?.user?.name && (
                    <ListItemAvatar sx={{ scale: 1.4, mr: "-33px" }}>
                      <AvatarLetter contact={observation.user} />
                    </ListItemAvatar>
                  )}
                  <ListItemText
                    primary={observation?.user?.name || ""}
                    primaryTypographyProps={{ variant: "h6" }}
                    secondary={`${t("Care.updated_on")}: ${parseDateToLgComun4(
                      observation.assigned
                    )}`}
                  />
                </ListItem>
                <Comments
                  text={observation.comment}
                  padding={0}
                  maxLength={300}
                  sx={{ mx: 0.5 }}
                  variant="body2"
                  color="secondary"
                  fontSize={14}
                />
              </Box>
            ))}
        </Box>
      ),
    },
  ];

  return (
    <Stack mt={reportDetail?.status?.current === currentReportStatus ? 2 : 0}>
      <EGAccordion panels={observationsPanel} defaultExpanded={1} />
    </Stack>
  );
};
